import { render } from "./SeasonStatsTable.vue?vue&type=template&id=b93290a4&scoped=true"
import script from "./SeasonStatsTable.vue?vue&type=script&lang=js"
export * from "./SeasonStatsTable.vue?vue&type=script&lang=js"

import "./SeasonStatsTable.vue?vue&type=style&index=0&id=b93290a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b93290a4"]])

export default __exports__